import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import { AppWrapperComponent } from 'app/app-wrapper.component';
import { AppWrapperV2Component } from 'app/app-wrapper-v2.component';
import {AuthGuardService} from '@core/services/auth-guard.service';
import { APP_ROUTING } from '@configs/constants';
import { environment } from '@env/environment';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
    canActivate: [AuthGuardService],
    data: {routeId: 'wizard'}
  },
  {
    // FMS (Fleet Management) is disabled for everyone — always show access denied.
    // Prefix match so all /fms/... deep links (fleet, policy, documents, etc.) are
    // blocked too. Keep this entry BEFORE the AppWrapperV2 catch-all below so it
    // takes precedence over the wrapper's '' route.
    path: 'fms',
    redirectTo: '/status-page/access-denied'
  },
  {
    // Standalone dev/demo tool: mock stream-event producer that pushes events
    // to the ms-convoy streams pipeline. Separate top-level module (not FMS).
    // Keep BEFORE the AppWrapperV2 catch-all below.
    path: 'stream-producer',
    loadChildren: () => import('./modules/stream-producer/stream-producer.module').then(m => m.StreamProducerModule),
    canActivate: [AuthGuardService],
  },
  {
    path: '',
    // path: APP_ROUTING.main,
    component: AppWrapperV2Component,
    loadChildren: () => import('./app-wrapper.module').then(m => m.AppWrapperModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}

